import request from '@/utils/request'

/**
 * 查询保证金明细
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAccountBondObjDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBondObjDetail/queryAccountBondObjDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryBondShops(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}